module.exports = __webpack_public_path__ + "static/media/news-ptsd.cf142082.jpg";